<div class="inputGroupMasked form-group">
  <label for="exampleFormControlInput1" class="form-label mt-3">{{ label }}</label>
  <div class="inputGroupMasked-inputWrapper">
    <input
      class="inputGroupMasked-input"
      [type]="hidden ? 'password' : 'text'"
      *ngFor="let number of [].constructor(length); let i = index"
      [id]="'cet-passcode-' + i + label.split(' ')[0]"
      [pattern]="oneIntegerPattern"
      [(ngModel)]="passcode[i]" sensitive-data
      #input
      (input)="emitOrNext(i, $event)"
      (keyup.backspace)="emitOrPrev(i)"
      autocomplete="off"
      maxlength="1"
    />

    <button
      class="inputGroupMasked-button"
      style="color: #74c145; font-size: 20px"
      (click)="hidden = !hidden"
    >
      <i class="bi bi-eye-fill" *ngIf="hidden"></i>
      <i class="bi bi-eye-slash-fill" *ngIf="!hidden"></i>
    </button>
  </div>
</div>
